<template>
  <pt-notes-table class="pt-notes-table__withData" @getTableData="getTableData" :totalNumber="totalNumber" :tableData="tableData" ref="table"
                  :isTwentiethSurvey="isTwentiethSurvey" @chooseRecord="chooseRecord" :isTwentyAnniversary="isTwentyAnniversary" :isSelect="isSelect"
                  :isOutside="isOutside" :isParse="isParse" :isReportQuestion="isReportQuestion" :isQuestion="isQuestion"
                  :isLifeExperienceHall="isLifeExperienceHall">
    <slot />
  </pt-notes-table>
</template>

<script>
import PtNotesTable from './index'
export default {
  name: 'pt-notes-table__withData',
  components: {
    'pt-notes-table': PtNotesTable
  },
  props: {
    id: {
      type: String
    },
    searchKey: {
      type: String
    },
    paramsData: {
      type: Object
    },
    isFromRouter: {
      type: Boolean
    },
    isParse: {
      type: Boolean
    },
    isReportQuestion: {
      type: Boolean
    },
    isQuestion: {
      type: Boolean
    },
    isLifeExperienceHall: {
      type: Boolean
    },
    isSelect: {
      type: Boolean,
      default: false
    },
    isTwentyAnniversary: {
      type: Boolean,
      default: false
    },
    isTwentiethSurvey: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    page () {
      return this.$refs.table.page
    }
  },
  data () {
    return {
      totalNumber: null,
      pageSize: 10,
      tableData: [],
      loading: false,
      isOutside: false
    }
  },
  watch: {
    paramsData: {
      handler: function (val) {
        if (this.isFromRouter) {
        //   this.getTableData(0)
          this.isOutside = true
          this.getTableData(this.page)
        } else {
          this.resetPage()
        }
      },
      deep: true
    }
  },
  methods: {
    resetPage () {
      this.$refs.table.resetPage()
    },
    getTableData (page, next) {
      let data = {
        mallRegistrationId: this.id,
        pageableParam: {
          page: this.page,
          size: this.pageSize,
        },
        ...this.paramsData
			}
			if(this.isParse){
				data.pageableParam.sort='genericFormData.data.parseDate,desc'
			}
      if (!next) {
        this.loading = true
      }
      this.$store.dispatch('getSignNotes', data).then(res => {
        if (next) {
          next(res.data)
        } else {
          this.loading = false
        }
        this.totalNumber = res.totalNumber
        this.tableData = res.data
      }).catch(err => {
        this.loading = false
        this.$refs.table.showReTry()
        this.$message.error(err || '获取报名记录列表失败')
      })
    },
    chooseRecord (selection) {
      this.$emit('chooseRecord', selection)
    }
  }
}
</script>
